import React from "react";
import classNames from "classnames";
import PropTypes from 'prop-types';
import './IconClose.scss'

export default function IconClose(props) {
	return (
		<i
			{...props}
			className={classNames(['icon-close', props.className])}>
		</i>
	)
}

IconClose.propTypes = {
	onClick: PropTypes.func,
	className: PropTypes.string,
}